jQuery(document).ready(function ($) {
  $(".cases__cases").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    appendDots: $(".cases__control"),
    infinite: false,
    adaptiveHeight: false,
    prevArrow: ".cases__arrow.arrow-prev",
    nextArrow: ".cases__arrow.arrow-next",
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  });

  $(".reviews__items").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    appendDots: $(".reviews__control"),
    infinite: false,
    adaptiveHeight: false,
    prevArrow: ".reviews__arrow.arrow-prev",
    nextArrow: ".reviews__arrow.arrow-next",
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  });
  
  $(document).ready(function() {
    $('a[href="#"]').on('click', function(event) {
      event.preventDefault();

      let target = $('#contact-form');
      if (!target.length) {
        target = $('#advice');
      }

      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 2000);
      }
    });
  });


  var maxHeight = 0;
  $(".cases__cases .slick-slide").each(function () {
    var slideHeight = $(this).outerHeight();
    if (slideHeight > maxHeight) {
      maxHeight = slideHeight;
    }
  });
  $(".cases__cases .slick-slide").css("height", maxHeight + "px");

  $('#language-mobile').on('click', function() {
    $('#langs-mobile, #language-mobile').toggleClass('active');
  });

  $('#menu-open').on('click', function() {
    $(this).hide();
    $('#menu-close').show();
    $('.header__nav-mobile, #header').addClass('active');
    $('body').css('overflow', 'hidden');
    $('#langs-mobile, #language-mobile').removeClass('active');
  });
  
  $('#menu-close').on('click', function() {
    $(this).hide();
    $('#menu-open').show();
    $('.header__nav-mobile, #header').removeClass('active');
    $('body').css('overflow', 'auto');
    $('#langs-mobile, #language-mobile').removeClass('active');
  });
  
  $('.header__nav-mobile a').on('click', function() {
    $('#menu-close').hide();
    $('#menu-open').show();
    $('.header__nav-mobile, #header').removeClass('active');
    $('body').css('overflow', 'auto');
  });
});

jQuery(document).ready(function ($) {
  $(".faq__list-single--question").on("click", function () {
    var parent = $(this).closest(".faq__list-single");

    parent.toggleClass("active");

    var answer = parent.find(".faq__list-single--answer");

    if (parent.hasClass("active")) {
      answer.css("height", "auto");
      var autoHeight = answer.height();
      answer.height(0);
      answer.animate({ height: autoHeight }, 100);
    } else {
      answer.animate({ height: 0 }, 100);
    }
  });

  $('.quote__menu-item').on('click', function() {
    $('.quote__menu-item').removeClass('active');
    $('.quote__item').removeClass('active');
    $(this).addClass('active');
    const index = $(this).index();
    $('.quote__item').eq(index).addClass('active');
  });

  $('.faq-mode').on('click', function() {
    var $this = $(this);
    if ($this.hasClass('active')) {
      $this.removeClass('active clip-block');
      $this.find('p').slideUp(300);
    } else {
      $('.faq-mode').removeClass('active clip-block').find('p').slideUp(300);
      $this.addClass('active clip-block');
      $this.find('p').slideDown(300);
    }
  });

  $(document).on('wpcf7mailsent', function(event) {
    let $form = $(event.target);
    let $button = $form.find('.wpcf7-submit');
    $button.addClass('off');
  });
});


// $(document).ready(function() {
//   $(".anchor a, .anchor-a").click(function(e) {
//       var href = $(this).attr("href");

//       // Перевірте, чи href починається з #
//       if (href && href.startsWith('#')) {
//           e.preventDefault();

//           var target = $(href);

//           if (target.length) {
//               var offset = target.offset().top - 100;
//               $("html, body").animate({
//                   scrollTop: offset
//               }, 1000);
//           }
//       } else {
//           // Якщо href не є якір, дозвольте звичайну навігацію
//           window.location.href = href;
//       }
//   });
// });